"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  properties: {
    collapsed: {
      type: 'boolean'
    },
    i18n: {
      type: 'boolean'
    }
  }
};